fourToldApp.controller("changepasswordCntrl", function ($scope,$sce,esb, services, $location, $mdToast, $route,  $window, $mdDialog, theme, $rootScope,  $localStorage) {
    $scope.progressCircular = true;
    $scope.theme = JSON.parse($window.sessionStorage.getItem("theme"));
    $scope.showMenuInChangePassword = false;
    $scope.showBackButtonBar = true;
    var activeDiv = document.querySelector('html');
    
  if ($scope.theme !== null) {
    $scope.commerceName = $scope.theme.app_name;
    $scope.icon = esb + "/security" + $scope.theme.small_icon;
    $rootScope.iconFavicon = esb + "/security" + $scope.theme.statusbar_icon;
    $scope.loginTheme = { backgroundColor: { backgroundColor: $scope.theme.backgroundColor }, button_Login_background_color: { backgroundColor: $scope.theme.button_Login_background_color, color: $scope.theme.button_Login_textcolor, 'font-weight': '400' }, button_Register_background_color: { backgroundColor: $scope.theme.button_Register_background_color, color: $scope.theme.button_Register_textcolor }, textColor: { color: $scope.theme.button_Register_textcolor } };
    activeDiv.setAttribute('style', 'background-color: white');


  } 
  $scope.theme = theme.getTheme();
  if ($scope.theme && $scope.theme.passwords)
    $scope.hints = $scope.theme.passwords.hints.replace(/(?:\r\n|\r|\n)/g, '<br>');

    
    if($window.sessionStorage.getItem('requiredPasswordChange')==='true'){
        $scope.showMenuInChangePassword = false;
        $scope.showBackButtonBar = true;
    }
    else{
      $scope.showBackButtonBar = false;
      $scope.showMenuInChangePassword = true;
    }    
  
    $scope.setFocus = function () {
      $scope.visible = true;
      return $scope.visible;
    }
  
    $scope.setBlur = function () {
      $scope.visible = false;
      return $scope.visible;
    }
  
    $scope.renderHtml = function (htmlCode) {
      return $sce.trustAsHtml(htmlCode);
    };
  
    $scope.reset = function (form) {
      $scope.register = {};
      $route.reload();
      $scope.aditional = {};
      if (form) {
        form.$setPristine();
        form.$setUntouched();
      }
    };
  
  
    $scope.dialog = function (message, type) {
      $scope.progressCircular = false;
      $mdToast.show(
        $mdToast.simple()
          .textContent(message)
          .position('top')
          .action('Ok')
          .theme(type)
          .hideDelay(0)
      );
    };
  
    $scope.showAlert = function (message) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('Notificación')
          .textContent(message)
          .ariaLabel('Alert Dialog Demo')
          .ok('Ok')
      );
    };
  
    $scope.showAlertChange = function (message) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('Notificación')
          .textContent(message)
          .ariaLabel('Alert Dialog Demo')
          .ok('Ok')
      ).finally(function () {
        $localStorage.selectedIndex = 'item-0';
        $location.path("/");
        
      });;
    };
  
    $scope.showConfirm = function (message) {
      var confirm = $mdDialog.confirm()
        .title('Notificación')
        .textContent(message)
        .ariaLabel('Lucky day')
        .ok('Ok');
      $mdDialog.show(confirm).then(function () {
        $scope.status = 'You decided to get rid of your debt.';
      });
    };
  
    $scope.match = function () {
      $scope.isMatch = angular.equals($scope.register.password, $scope.confirm);
      $scope.errorMessage = '';
    }
    $scope.changePassword = function (ev) {
      if($scope.register.currentPassword && $scope.register.password && $scope.confirm && $scope.isMatch)
          $scope.passwordChange($scope.register.currentPassword, $scope.register.password);      
    }
  
    $scope.toast = function (messenger, id) {
      toast.options.closeDuration = 500;
      if (id == 0) {
        toastr.error(messenger);
        $scope.error = true;
      } else if (id == 1) {
        toastr.success(messenger);
        $scope.success = true;
      }
    }
  
    $scope.passwordChange = function (oldPassword, newPassword) {
      $scope.send = "ok";
      $scope.invalid = undefined;
      $scope.errorMessage = '';
      services.update_password('bearer ' + $window.localStorage.getItem('access_token1')).password({ oldPassword: oldPassword, newPassword: newPassword }, function (response) {
        $scope.send = undefined;
        if (response.code == -24) {
          $scope.invalid = "yes";
          $scope.errorMessage = 'Contraseña actual inválida.';
        } else if(response.code == 1){
          $window.sessionStorage.setItem('requiredPasswordChange',false);
          $scope.errorMessage = '';
          $scope.showAlertChange('Contraseña actualizada exitosamente.', 1);
        } else if (response.code == -111) {
          $scope.invalid = "yes";
          let errorMessage = "La contraseña no cumple con las políticas de seguridad necesarias.";
          if (response.message){
            errorMessage = errorMessage +"\n";
            errorMessage += response.message ;
            errorMessage = errorMessage.replaceAll("\n", "<br/>");
          }
          $scope.errorMessage = errorMessage;
        } else if (response.code == -128) {
          $scope.invalid = "yes";
          let errorMessage = "La contraseña no cumple con las políticas de seguridad necesarias.";
          if (response.message){
            errorMessage = errorMessage +"\n";
            errorMessage += response.message ;
            errorMessage = errorMessage.replaceAll("\n", "<br/>");
          } else {
            errorMessage = errorMessage +"<br/>";
            errorMessage += "La nueva contraseña debe ser diferente a la contraseña anterior";
          }
          $scope.errorMessage = errorMessage;
        } else if (response.code == -5) {
          $scope.invalid = "yes";
          $scope.errorMessage = "La contraseña no cumple con las políticas de seguridad necesarias.";
        } else {
          $scope.invalid = "yes";
          $scope.errorMessage = 'Ha ocurrido un error, intente nuevamente mas tarde.';
        }
        
  
      }, function (error) {
  
      });
    }
  
  
    $scope.cancelChangePassword = function(){
      $localStorage.selectedIndex = 'item-0';
      $location.path("/");
    }

    
    $scope.visibilityPassword = function(id) {
      var x = document.getElementById(id);
      if (x.type === id) {
          x.type = "text";
          $scope.passwordVisibility = true;
      } else {
          x.type = "password";
          $scope.passwordVisibility = false;
      }
  }

  $scope.$on('$locationChangeStart', function(event, next, current){
    if($window.sessionStorage.getItem('requiredPasswordChange')==='true'){
      event.preventDefault();            
  }
    
});

if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
  $('#show_hide_password input').attr('type', 'password');
  $('#show_hide_password_confirm input').attr('type', 'password');
  $('#show_hide_current_password input').attr('type', 'password');
}
$('#sidebar').css('margin-left', 0);
$("#show_hide_current_password a").on('click', function (event) {
  event.preventDefault();
  if ($('#show_hide_current_password input').attr("type") == "text") {
    switch ($('#show_hide_current_password i').hasClass('fa-eye')) {
      case false:
        $('#show_hide_current_password i').removeClass("fa-eye-slash");
        $('#show_hide_current_password i').addClass("fa-eye");
        break;
      case true:
        $('#show_hide_current_password input').attr('type', 'password');
        $('#show_hide_current_password i').addClass("fa-eye-slash");
        $('#show_hide_current_password i').removeClass("fa-eye");
        break;
    }
    $('#txtCurrentPassword').css({
      'text-security': 'none',
      '-webkit-text-security': 'none',
      '-mox-text-security': 'none'
    });
  } else if ($('#show_hide_current_password input').attr("type") == "password") {
    switch ($('#show_hide_current_password i').hasClass('fa-eye-slash')) {
      case false:
        $('#show_hide_current_password i').addClass("fa-eye-slash");
        $('#show_hide_current_password i').removeClass("fa-eye");
        break;
      case true:
        $('#show_hide_current_password input').attr('type', 'text');
        $('#show_hide_current_password i').removeClass("fa-eye-slash");
        $('#show_hide_current_password i').addClass("fa-eye");
        break;
    }
  }
});

$("#show_hide_password a").on('click', function (event) {
  event.preventDefault();
  if ($('#show_hide_password input').attr("type") == "text") {
    switch ($('#show_hide_password i').hasClass('fa-eye')) {
      case false:
        $('#show_hide_password i').removeClass("fa-eye-slash");
        $('#show_hide_password i').addClass("fa-eye");
        break;
      case true:
        $('#show_hide_password input').attr('type', 'password');
        $('#show_hide_password i').addClass("fa-eye-slash");
        $('#show_hide_password i').removeClass("fa-eye");
        break;
    }
    $('#txtPassword').css({
      'text-security': 'none',
      '-webkit-text-security': 'none',
      '-mox-text-security': 'none'
    });
  } else if ($('#show_hide_password input').attr("type") == "password") {
    switch ($('#show_hide_password i').hasClass('fa-eye-slash')) {
      case false:
        $('#show_hide_password i').addClass("fa-eye-slash");
        $('#show_hide_password i').removeClass("fa-eye");
        break;
      case true:
        $('#show_hide_password input').attr('type', 'text');
        $('#show_hide_password i').removeClass("fa-eye-slash");
        $('#show_hide_password i').addClass("fa-eye");
        break;
    }
  }
});

$("#show_hide_password_confirm a").on('click', function (event) {
  event.preventDefault();
  if ($('#show_hide_password_confirm input').attr("type") == "text") {
    switch ($('#show_hide_password_confirm i').hasClass('fa-eye')) {
      case false:
        $('#show_hide_password_confirm i').removeClass("fa-eye-slash");
        $('#show_hide_password_confirm i').addClass("fa-eye");
        break;
      case true:
        $('#show_hide_password_confirm input').attr('type', 'password');
        $('#show_hide_password_confirm i').addClass("fa-eye-slash");
        $('#show_hide_password_confirm i').removeClass("fa-eye");
        break;
    }
    $('#txtPasswordConfirm').css({
      'text-security': 'none',
      '-webkit-text-security': 'none',
      '-mox-text-security': 'none'
    });
  } else if ($('#show_hide_password_confirm input').attr("type") == "password") {
    switch ($('#show_hide_password_confirm i').hasClass('fa-eye-slash')) {
      case false:
        $('#show_hide_password_confirm i').addClass("fa-eye-slash");
        $('#show_hide_password_confirm i').removeClass("fa-eye");
        break;
      case true:
        $('#show_hide_password_confirm input').attr('type', 'text');
        $('#show_hide_password_confirm i').removeClass("fa-eye-slash");
        $('#show_hide_password_confirm i').addClass("fa-eye");
        break;
    }
  }
});


  
  });
  